import React from "react";
import styled from "styled-components";
import { Button, Input, Table } from "components/bootstrap";
import ObjectUtils from "util/ObjectUtils";
const StyledDiv = styled.div`
  .form-group {
    margin-left: 0;
    margin-right: 0;
  }
`;
class KeyValueTable extends React.Component {
  constructor(props) {
    super(props);
    this._onPairsChange = (newPairs) => {
      if (this.props.onChange) {
        this.props.onChange(newPairs);
      }
    };
    this._bindValue = (event) => {
      const newState = {};
      newState[event.target.name] = event.target.value;
      this.setState(newState);
    };
    this._addRow = () => {
      const newPairs = ObjectUtils.clone(this.props.pairs);
      newPairs[this.state.newKey] = this.state.newValue;
      this._onPairsChange(newPairs);
      this.setState({ newKey: "", newValue: "" });
    };
    this._deleteRow = (key) => () => {
      if (window.confirm(`Are you sure you want to delete property '${key}'?`)) {
        const newPairs = ObjectUtils.clone(this.props.pairs);
        delete newPairs[key];
        this._onPairsChange(newPairs);
      }
    };
    this._formattedHeaders = (headers) => /* @__PURE__ */ React.createElement("tr", null, headers.map((header, idx) => {
      const customStyle = {};
      if (idx === headers.length - 1) {
        if (!this.props.editable) {
          return null;
        }
        customStyle.width = 75;
      }
      return /* @__PURE__ */ React.createElement("th", { key: header, style: customStyle }, header);
    }));
    this._formattedRows = (pairs) => Object.keys(pairs).sort().map((key) => {
      let actionsColumn;
      if (this.props.editable) {
        const actions = [];
        actions.push(
          /* @__PURE__ */ React.createElement(
            Button,
            {
              key: `delete-${key}`,
              bsStyle: "danger",
              bsSize: this.props.actionsSize,
              onClick: this._deleteRow(key)
            },
            "Delete"
          )
        );
        actionsColumn = /* @__PURE__ */ React.createElement("td", null, actions);
      }
      return /* @__PURE__ */ React.createElement("tr", { key }, /* @__PURE__ */ React.createElement("td", null, key), /* @__PURE__ */ React.createElement("td", null, pairs[key]), actionsColumn);
    });
    this._newRow = () => {
      if (!this.props.editable) {
        return null;
      }
      const addRowDisabled = !this.state.newKey || !this.state.newValue;
      return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(StyledDiv, null, /* @__PURE__ */ React.createElement(
        Input,
        {
          type: "text",
          name: "newKey",
          id: "newKey",
          "data-testid": "newKey",
          placeholder: this.props.headers[0],
          value: this.state.newKey,
          onChange: this._bindValue
        }
      ))), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(StyledDiv, null, /* @__PURE__ */ React.createElement(
        Input,
        {
          type: "text",
          name: "newValue",
          id: "newValue",
          "data-testid": "newValue",
          placeholder: this.props.headers[1],
          value: this.state.newValue,
          onChange: this._bindValue
        }
      ))), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small", onClick: this._addRow, disabled: addRowDisabled }, "Add")));
    };
    this.state = {
      newKey: "",
      newValue: ""
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "key-value-table-component" }, /* @__PURE__ */ React.createElement("div", { className: `table-responsive ${this.props.containerClassName}` }, /* @__PURE__ */ React.createElement(Table, { className: `table table-striped ${this.props.className}` }, /* @__PURE__ */ React.createElement("thead", null, this._formattedHeaders(this.props.headers)), /* @__PURE__ */ React.createElement("tbody", null, this._formattedRows(this.props.pairs), this._newRow()))));
  }
}
KeyValueTable.defaultProps = {
  headers: ["Name", "Value", "Actions"],
  editable: false,
  actionsSize: "xsmall",
  className: "",
  containerClassName: "",
  onChange: () => {
  }
};
export default KeyValueTable;
